import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CheckListGroup, CheckListGroupPayload, CheckListItem, CheckListItemPayload } from './check-list.model';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class CheckListApiService {
	private readonly apiUrl = environment.apiUrl;
	private readonly httpClient = inject(HttpClient);

	getCheckListItems(limit: number, offset: number, filters = ''): Observable<Result<CheckListItem>> {
		return this.httpClient.get<Result<CheckListItem>>(
			`${this.apiUrl}/checklist/item/?limit=${limit}&offset=${offset}&${filters}`,
		);
	}

	getCheckListGroups(limit: number, offset: number, filters = ''): Observable<Result<CheckListGroup>> {
		return this.httpClient.get<Result<CheckListGroup>>(
			`${this.apiUrl}/checklist/group/?limit=${limit}&offset=${offset}&${filters}`,
		);
	}

	createCheckListItem(payload: CheckListItemPayload): Observable<CheckListItem> {
		return this.httpClient.post<CheckListItem>(`${this.apiUrl}/checklist/item/`, payload);
	}

	updateCheckListItem(payload: CheckListItem): Observable<CheckListItem> {
		return this.httpClient.put<CheckListItem>(`${this.apiUrl}/checklist/item/${payload.id}/`, payload);
	}

	createCheckListGroup(payload: CheckListGroupPayload): Observable<CheckListGroup> {
		return this.httpClient.post<CheckListGroup>(`${this.apiUrl}/checklist/group/`, payload);
	}

	updateCheckListGroup(payload: CheckListGroup): Observable<CheckListGroup> {
		return this.httpClient.put<CheckListGroup>(`${this.apiUrl}/checklist/group/${payload.id}/`, payload);
	}
}
